import React from "react";
import styled from "styled-components";
import { Consumer } from "../context/InfoContext";
import Row from "../dev/Row";
import Span from "../dev/Span";
import RadarCharts from "./Creator/RadarChart";
import Tags from "./Creator/Tags";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Guide from "../dev/Guide";
import StyleLink from '../dev/StyleLink'

const Creator = props => {
    const {
        messages,
        infoId,
        tour
    } = props;
    return (
        <Consumer>
            {value => (
                <CreatorDefaultWrap>
                    <CreatorDefault id="user_tour_info_2">
                        <Row padding="24px 0 0 24px" position='relative' zIndex={2} width='100%'>
                            <Row>
                                <Span spanTitle>{messages.info_info}</Span>
                                <Guide
                                    tourId={"user_tour_info_3"}
                                    list={[
                                        messages.dataDesc_subscriberCount,
                                        messages.dataDesc_totalViewCount,
                                        // messages.dataDesc_totalEngegementCount,
                                        [`${messages.avgEngageRate} ${messages.dataDesc_equal}`, {numerator: messages.dataDesc_avgEngageRate_2 ,denominator: messages.dataDesc_avgEngageRate_3}],
                                        messages.dataDesc_videoCount,
                                    ]}
                                    position='-45%'
                                />
                            </Row>
                        </Row>
                        <Row padding="10px 0 24px 24px" borderbottom lineHeight="1.1rem">
                            <Row direction="column">
                                <Span>{messages.subscriberCount}</Span>
                                <Span>{messages.totalViewCount}</Span>
                                {/*<Span>{messages.totalEngegementCount}</Span>*/}
                                <Span>{messages.avgEngageRate}</Span>
                                <Span>{messages.videoCount}</Span>
                            </Row>
                            <Row direction="column" padding="0px 0px">
                                <CurrentSubscriberWrap>
                                    <Span>{value.subscriberCount}</Span>
                                    <StyleLink to={`/CurrentSubscriber/${infoId}`} onClick={()=> window.scrollTo(0,0)}>
                                        <LiveButton>Live</LiveButton>                                    
                                    </StyleLink>
                                </CurrentSubscriberWrap>
                                <Span isBlur={value.isBlur}>{value.totalViewCount}</Span>
                                {/*<Span>{value.totalEngageCount}</Span>*/}
                                <Span isBlur={value.isBlur}>{value.avgEngageRate}%</Span>
                                <Span isBlur={value.isBlur}>{value.videoCount}</Span>
                            </Row>
                        </Row>
                        <Row direction="column" padding="24px" borderbottom position='relative' zIndex={0}>
                            <Row>
                                <Span spanTitle>{messages.info_theme}</Span>
                                <Guide
                                    tourId={"user_tour_info_3"}
                                    list={[
                                        messages.dataDesc_videoTheme,
                                    ]}
                                    position='-45%'
                                />
                            </Row>
                            <Tags data={value.tags} isBlur={value.isBlur}/>
                        </Row>
                        <Row direction="column" height="220px" padding="24px" position='relative' zIndex={0}>
                            <Row>
                                <Span spanTitle>{messages.info_category}</Span>
                                <Guide
                                    tourId={"user_tour_info_3"}
                                    list={[
                                        messages.dataDesc_videoCategory
                                    ]}
                                    position='-45%'
                                />
                            </Row>
                            <Mask isBlur={value.isBlur}>
                                <RadarCharts data={value.topics} isBlur={value.isBlur}/>
                            </Mask>
                        </Row>
                    </CreatorDefault>
                </CreatorDefaultWrap>
            )}
        </Consumer>
    );
};
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        tour: state.Tour,
    };
};
export default withRouter(connect(mapStateToProps)(Creator));
//export default Creator;

const CreatorDefaultWrap = styled.div`
    grid-area: creator;
`;
const CreatorDefault = styled.div`
    display: flex;
    flex-direction: column;
    /* height: auto; */
    background-color: #ffffff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    .recharts-surface {
        font-size: 10px;
    }
    .recharts-polar-angle-axis-tick {
        fill: #666666;
    }
`;
const Mask = styled.div`
    width: 100%;
    height: 100%;
    ${({ isBlur }) => isBlur ? 'filter: blur(2px)' : ''};
`
const LiveButton = styled.div`
    display: flex;
    align-items: center;
    margin-left: 8px;
    padding: 0 5px;
    border-radius: 5px;
    height: 1rem;
    color: #fff;
    background-color: rgba(222,6,6,.8);
    /* text-decoration: underline; */
    font-size: 12px;
    cursor: pointer;
`
const CurrentSubscriberWrap = styled.div`
    display: flex;
    align-items: center;
`


// WEBPACK FOOTER //
// ./src/Info/Creator.js